export default "__VITE_PUBLIC_ASSET__71810177__"